<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            placeholder="Selecione Profissional..."
                            icon="fas fa-user-md fa-fw"
                            type="select"
                            optionsMode="aql"
                            service="medicos.index"
                            optionsName="medicos-cadastro"
                            :optionsParm="{ ativos: true }"
                            v-model="medico" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            placeholder="Não Repassados"
                            icon="fas fa-filter fa-fw"
                            type="select"
                            optionsMode="json"
                            :optionsList="[
                                { id: 'S', search: 'Repassados' },
                                { id: 'T', search: 'Todos' },
                            ]"
                            optionsData="id"
                            :edicao="medico ? true : false"
                            v-model="filtros.repassados" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input
                            placeholder="Todos..."
                            icon="fas fa-percent fa-fw"
                            type="select"
                            optionsMode="json"
                            :optionsList="[
                                { id: 'S', search: 'Sem Rateio' },
                                { id: 'N', search: 'Com Rateio' },
                            ]"
                            optionsData="id"
                            v-model="filtros.sem_rateio" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input 
                            icon="fas fa-filter fa-fw"
                            placeholder="Especialidades..."
                            type="select" 
                            service="especialidades.index"
                            optionsData="id_especialidade"
                            optionsDisplay="search"
                            optionsName="esp-todas"
                            optionsMode="aql"
                            :optionsParm="{ ativas: true }"
                            v-model="filtros.id_especialidade">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="far fa-building fa-fw"
                            type="select"
                            placeholder="Unidades..."
                            :optionsList="$util.unidades_com_tags(true, true)"
                            optionsData="id_unidade_operacao"
                            v-model="filtros.id_unidade_operacao" />
                    </div>
                    <div class="col col-12 col-md-6">
                        <az-input
                            type="text"
                            icon="fa fa-search fa-fw"
                            placeholder="Pesquisar..."
                            v-model="search">
                            <template v-slot:buttonposb>
                                <print-export printid="lista-rateios" :dados="dadosFormatados" />
                            </template>
                        </az-input>
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12">
                        <az-input
                            sizing="sm"
                            type="button-group"
                            :optionsList="[
                                { id: 'D', search: 'Detalhado' },
                                { id: 'T', search: 'Por Tipo' },
                                { id: 'M', search: 'Por Profissional' },
                                { id: 'R', search: 'Por Repasse' },
                            ]"
                            optionsData="id"
                            v-model="view" />
                    </div>
                </div>

            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && dados && dados.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state :msg="!medico ? 'Selecione o Profissional' : 'Nenhum atendimento localizado'" icon="fas fa-search" v-if="lista_vazia" />

        <template v-if="!lista_vazia">

            <div id="lista-rateios">

                <cabecalho-generico titulo="Rateios">
                    <div>{{ medico_selec.st_nome_exibicao }}</div>
                </cabecalho-generico>

                <template v-if="view != 'D'">

                    <table class="table table-responsive-md bg-white table-hover small cabecalho-fixo">
                        <thead>
                            <tr>
                                <th>Descrição</th>
                                <th class="text-right">Valor</th>
                                <th class="text-right">Rateio</th>
                                <th class="text-right" v-if="medico_selec">Repassado</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(itens, grupo, igx) in lista" :key="igx">
                                <td>{{ grupo == 'undefined' ? '-' : grupo }}</td>
                                <td class="text-right">
                                    {{ $util.formatMoeda(total_geral(itens, 'cd_valor_total')) }}
                                </td>
                                <td class="text-right">
                                    {{ $util.formatMoeda(total_geral(itens, 'rateio')) }}
                                </td>
                                <td class="text-right" v-if="medico_selec">
                                    {{ $util.formatMoeda(total_geral(itens, 'repassado')) }}
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th>
                                    Total
                                    <span class="badge badge-secondary ml-2">
                                        {{ lista.length }}
                                    </span>
                                </th>
                                <th class="text-right">
                                    {{ $util.formatMoeda(total_geral(lista, 'cd_valor_total', true)) }}
                                </th>
                                <th class="text-right">
                                    {{ $util.formatMoeda(total_geral(lista, 'rateio', true)) }}
                                </th>
                                <th class="text-right" v-if="medico_selec">
                                    {{ $util.formatMoeda(total_geral(lista, 'repassado', true)) }}
                                </th>
                            </tr>
                        </tfoot>
                    </table>

                </template>

                <template v-else>

                    <!-- Visão Detalhada -->

                    <table class="table table-responsive-md bg-white table-hover small cabecalho-fixo">
                        <thead>
                            <tr>
                                <th width="10%">Data</th>
                                <th width="24%">Paciente</th>
                                <th width="28%">Procedimento</th>
                                <th width="19%">Regra</th>
                                <th width="8%" class="text-right">Valor</th>
                                <th width="8%" class="text-right">Rateio</th>
                                <th width="4%" class="text-right" v-if="medico_selec">Repassado</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(atp, iax) in lista">
                                <tr :key="iax">
                                    <td width="10%">
                                        <div>{{ $util.getFormatDate(atp.dt_inicio) }}</div>
                                        <div>
                                            <a href="#" @click.prevent="abrir_atendimento(atp)" class="card-link">
                                                #{{ atp.id_atendimento }}
                                            </a>
                                            <i class="fas fa-calendar-day ml-2" v-if="atp.eventual" title="Agenda Eventual"></i>

                                            <a href="#" @click.prevent="ver_guia(atp.atendimento_procedimento_guia.guia)">
                                                <span class="badge ml-2" :class="'badge-' + atp.atendimento_procedimento_guia.guia.status_color" 
                                                    :title="'Status da Guia: ' + atp.atendimento_procedimento_guia.guia.status_guia" 
                                                    v-if="atp.atendimento_procedimento_guia && atp.atendimento_procedimento_guia.guia">
                                                    {{ atp.atendimento_procedimento_guia.guia.ch_status }}
                                                </span>
                                            </a>
                                        </div>
                                    </td>
                                    <td width="24%">
                                        <div>{{ atp.paciente.st_nome }}</div>

                                        <div class="text-muted" v-if="atp.plano_particular">
                                            {{ atp.plano_particular.search }}
                                        </div>
                                        <div class="text-muted" v-else>{{ atp.plano.search }}</div>
                                    </td>
                                    <td width="40%">
                                        {{ atp.procedimento.search }}
                                        <span class="badge badge-secondary" v-if="atp.in_quantidade > 1">
                                            x{{ atp.in_quantidade }}
                                        </span>
                                        <div class="text-muted">
                                            {{ atp.medico.search }}
                                            <span class="badge badge-light ml-2" title="Unidade de Atendimento">{{ atp.unid_sigla }}</span>
                                            <span class="badge badge-dark ml-2" v-if="atp.ap_sigla" title="Apoiado">{{ atp.ap_sigla }}</span>
                                        </div>
                                        <div v-if="atp.item_repasses.length">
                                            <span v-for="(rep, irx) in atp.item_repasses" :key="irx">
                                                <i class="fa fa-caret-right mx-2" aria-hidden="true" v-if="irx"></i>
                                                <span class="badge" :class="( medico && rep.medico_repasse.id_medico == medico_selec.id_pessoa ) ? 'badge-primary' : 'badge-secondary'" v-if="rep.medico_repasse" title="Repasse">
                                                    #{{ rep.medico_repasse.id_repasse }}
                                                    <span v-if="rep.medico_repasse.id_medico != medico_selec.id_pessoa">
                                                        / {{ rep.medico_repasse.medico.st_nome_exibicao }}
                                                    </span>
                                                </span>
                                                <span class="badge badge-secondary" v-else title="MR">
                                                    MR{{ rep.id_medico_repasse }}
                                                </span>
                                            </span>
                                        </div>
                                    </td>
                                    <td width="26%">
                                        <template v-if="!atp.item_repasses || !atp.item_repasses.length">
                                            <a href="#" class="card-link mr-2" @click.prevent="editar_rateio(atp)" v-if="atp.id_rateio_medico">
                                                <i class="fas fa-edit text-success fa-fw" title="Critério específico criado." v-if="atp.rateio_medico && atp.rateio_medico.fl_especifico"></i>
                                                <i class="fas fa-pen fa-fw" v-else title="Editar critério específico."></i>
                                            </a>
                                            <a href="#" class="card-link ml-0 mr-2" @click.prevent="recalcular_rateio(atp)">
                                                <i class="fas fa-sync-alt"></i>
                                            </a>
                                        </template>

                                        <span class="badge badge-danger" v-if="!atp.id_rateio_medico">Sem Rateio</span>
                                        <a href="#" @click.prevent="ver_criterio(atp.id_rateio_medico)" class="card-link mx-0" v-else>
                                            #{{ atp.id_rateio_medico }}
                                            <small v-if="atp.rateio_medico && atp.rateio_medico.st_titulo">
                                                {{ atp.rateio_medico.st_titulo }}
                                            </small>
                                        </a>
                                        <span class="ml-2" v-if="atp.rateio_medico && atp.rateio_medico.ch_tipo_repasse && atp.rateio_medico.ch_tipo_repasse != 'P'">
                                            <span class="badge" :class="atp.rateio_medico.ch_tipo_repasse == 'F' ? 'badge-primary' : 'badge-success'">
                                                {{ atp.rateio_medico.ch_tipo_repasse }}
                                            </span>
                                        </span>
                                    </td>

                                    <td width="12%" class="text-right">
                                        {{ $util.formatMoeda(atp.cd_valor_total) }}
                                        <div class="text-muted" v-if="atp.base_repasse && Math.round(atp.cd_valor_total * 100) != Math.round(atp.base_repasse * 100)">
                                            {{ $util.formatMoeda(atp.base_repasse) }}
                                        </div>
                                    </td>
                                    <td width="12%" class="text-right">
                                        {{ $util.formatMoeda(atp.rateio) }}
                                    </td>
                                    <td width="5%" class="text-right" v-if="medico_selec">
                                        <template v-if="atp.repassado">
                                            {{ $util.formatMoeda(atp.repassado) }}
                                        </template>
                                    </td>
                                </tr>

                                <template v-if="atp.detalhe_consumo && atp.detalhe_consumo.length">
                                    <tr v-for="(consumo, icx) in atp.detalhe_consumo" :key="'C' + iax + '.' + icx">
                                        <td></td>
                                        <td></td>
                                        <td class="text-muted">{{ consumo.search }}
                                            <span class="badge badge-secondary" v-if="consumo.qtd > 1">
                                                x{{ consumo.qtd }}
                                            </span>
                                        </td>
                                        <td></td>
                                        <td class="text-right text-muted">{{ $util.formatMoeda(consumo.base) }}</td>
                                        <td class="text-right text-muted" v-if="medico_selec"><span class="mr-2">{{ $util.formatMoeda(consumo.rateio) }}</span></td>
                                    </tr>
                                </template>
                            </template>

                        </tbody>
                        <tfoot>
                            <tr>
                                <th colspan="4">
                                    Total
                                    <span class="badge badge-secondary ml-2">
                                        {{ lista.length }}
                                    </span>
                                </th>
                                <th class="text-right">
                                    {{ $util.formatMoeda(total_geral(lista, 'cd_valor_total')) }}
                                </th>
                                <th class="text-right">
                                    {{ $util.formatMoeda(total_geral(lista, 'rateio')) }}
                                </th>
                                <th class="text-right" v-if="medico_selec">
                                    {{ $util.formatMoeda(total_geral(lista, 'repassado')) }}
                                </th>
                            </tr>
                        </tfoot>
                    </table>

                </template>

            </div>

            <br><br><br><br><br>

            <nav class="navbar fixed-bottom navbar-light bg-light">
                <a class="navbar-brand" href="#" @click.prevent>
                    &nbsp;
                </a>
                <div class="mr-3">
                    <az-submit sizing="sm" @click="recalcular_rateios()">
                        <i class="fas fa-sync-alt mr-2"></i>
                        Recalcular Rateios
                    </az-submit>
                </div>
            </nav>

        </template>

        <pre v-if="false">{{ dados }}</pre>

        <edicao-rateio-medico ref="cadrateio" :viewonly="true" @refresh="load()" />
        <guia-edicao :viewonly="true" ref="guiaedicao" />

         <!-- Dispatch -->
        <az-dispatch ref="dispatchModal" titulo="Recalculando Rateios..." @refresh="load()" />

    </div>

</template>

<script>
import _ from 'lodash';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import EdicaoRateioMedico from '../../cadastros/shared/EdicaoRateioMedico.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import PrintExport from '../../shared/PrintExport.vue'
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import AzDispatch from "../../util/AzDispatch.vue";
import GuiaEdicao from '../faturamento/GuiaEdicao.vue';

export default {
    data() {
        return {
            inicio: this.$util.hoje(),
            fim: this.$util.hoje(),
            medico: "",
            search: "",
            dados: [],
            filtros: {
                id_especialidade: "", 
                id_unidade_operacao: "", 
                inicio: "",
                fim: "",
                periodo: "h",
                mes: "",
                repassados: "",
                sem_rateio: "",
            },
            medico_selec: null,
            view: 'D',
        }
    },

    components: {
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzPeriodo,
        EdicaoRateioMedico,
        PrintExport,
        CabecalhoGenerico,
        AzDispatch,
        GuiaEdicao,
    },

    computed: {
        dadosFormatados: function () { 

            return this.lista.flatMap(atp => { 
                let item = { 
                    id_atendimento: atp.id_atendimento,
                    data: this.$util.getFormatDate(atp.dt_inicio), 
                    paciente: atp.paciente.st_nome, 
                    plano: atp.plano_particular ? atp.plano_particular.search : atp.plano.search,
                    descricao: atp.procedimento.search,
                    quantidade: atp.in_quantidade,
                    medico: atp.medico.search, 
                    id_rateio: atp.id_rateio_medico, 
                    rateio: atp.rateio_medico ? atp.rateio_medico.st_titulo : 'Sem Rateio', 
                    valor_atendimento: this.$util.formatMoeda(atp.cd_valor_total), 
                    valor_base: this.$util.formatMoeda(atp.base_repasse), 
                    valor_rateio: this.$util.formatMoeda(atp.rateio),
                    valor_repassado: this.$util.formatMoeda(atp.repassado), 
                };

                let lista = [item];

                if ( atp.detalhe_consumo && atp.detalhe_consumo.length ) { 
                    let consumos = atp.detalhe_consumo.map(consumo => { 
                        let retorno = _.cloneDeep(item);
                        
                        retorno.descricao = consumo.search;
                        retorno.quantidade = consumo.qtd;
                        retorno.valor_atendimento = "";
                        retorno.valor_base = this.$util.formatMoeda(consumo.base);
                        retorno.valor_rateio = this.$util.formatMoeda(consumo.rateio);

                        return retorno;
                    });

                    lista = lista.concat(consumos);
                }

                return lista;
            });

        },

        lista: function () {
            if ( !this.dados )
                return [];

            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            if ( this.view != 'D' ) {

                let campo_grupo = "";

                switch (this.view) {
                    case 'T':
                        campo_grupo = 'rateio_medico.st_titulo';
                        break;

                    case 'M':
                        campo_grupo = 'medico.st_nome_exibicao';
                        break;

                    case 'R':
                        campo_grupo = 'info_repasse.titulo_repasse';
                        break;

                    default:
                        break;
                }

                let items = this.dados.filter(item => {
                    return ( !this.search || this.search.substr(0,1) == '#' || reg.test(JSON.stringify(item)) );
                });

                items = _.groupBy(
                    _.sortBy(items, item => _.get(item, campo_grupo))
                    , campo_grupo
                );

                /*
                items = _.mapValues(items, atps => {
                    return {
                        paciente: atps[0].paciente,
                        plano: atps[0].plano,
                        atendimento: {
                            atendimento_procedimentos: atps,
                        },
                    };
                });
                */

                // console.log(2, items);

                return items;

            }

            let items = this.dados.filter(item => {
                return ( !this.search || this.search.substr(0,1) == '#' || reg.test(JSON.stringify(item)) );
            });

            return items;
        },

        lista_vazia: function () {
            return !this.lista || !_.keys(this.lista).length;
        }
    },

    methods: {
        ver_guia (guia) { 
            this.$refs.guiaedicao.abrir(guia);
        },

        editar_rateio (atp) {
            this.$refs.cadrateio.editar(
                atp.id_rateio_medico,
                true,
                atp.id_atendimento_procedimento,
                atp.id_atendimento_procedimento_equipe
            );
        },

        abrir_atendimento (atp) {
            this.$util.abrir_atendimento(this, atp.id_atendimento);
        },

        total_saldo (lista) {

            if ( !this.medico_selec )
                return;

            return _.reduce(
                    lista,
                    (totalg, marcacao) => totalg + marcacao.atendimento.atendimento_procedimentos
                        .filter(atp => !atp.item_repasses.find(ir => ir.medico_repasse.id_medico == this.medico_selec.id_pessoa))
                        .reduce((totala, atp) => totala + parseFloat(atp.valor_rateio), 0),
                    0
            );

        },

        total_geral (lista, campo, flat = false) {

            if ( !this.medico_selec )
                return;

            if ( flat ) {
                lista = _.flatMap(lista, item => item);
            }

            return _.reduce(
                lista,
                (totalg, item) => totalg + parseFloat(item[campo]),
                0
            );

        },

        repasse_do_medico (atp, campo) {
            if ( !this.medico_selec )
                return;

            return atp.item_repasses.filter(ir => ir.medico_repasse.id_medico == this.medico_selec.id_pessoa)
                .reduce((total, carry) => {
                    return total + parseFloat(carry[campo]);
                }, 0);
        },

        recalcular_rateio (atp) {
            this.$util.atualizar(this, {
                service: 'repasses',
                func: 'recalcular_rateio',
                dados: {
                    id_atendimento_procedimento: atp.id_atendimento_procedimento,
                    id_atendimento_procedimento_equipe: atp.id_atendimento_procedimento_equipe
                },
                toast: true,
                callback: res => {
                    if ( res && res.id_rateio_medico == atp.id_rateio_medico ) {
                        //
                    } else {
                        this.load();
                    }
                }
            });
        },

        recalcular_rateios () {

            let items = this.lista.filter(atp => !atp.item_repasses || !atp.item_repasses.length)
                .map(atp => {
                    return {
                        id_atendimento_procedimento: atp.id_atendimento_procedimento,
                        id_atendimento_procedimento_equipe: atp.id_atendimento_procedimento_equipe,
                        id_rateio_medico: atp.id_rateio_medico,
                        geral: true,
                    };
                });

            if ( !items.length ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: "Nenhum lançamento disponível para recálculo de critério de rateio.",
                    life: 4000
                });
                return;
            }

            // this.$util.atualizar(this, {
            //     service: 'repasses',
            //     func: 'recalcular_rateios',
            //     dados: {
            //         lista: items,
            //     },
            //     toast: true,
            //     callback: () => {
            //         this.load();
            //     }
            // });

            this.$refs.dispatchModal.executar_chunck(
                'repasses',
                "recalcular_rateios",
                items,
                'lista',
                {},
                50
            );
        },

        load() {
            this.dados = null;
            this.medico_selec = this.medico;

            this.$nextTick(() => {

                this.$util.load(this, {
                    service: 'repasses',
                    func: 'rateios',
                    parms: {
                        ...this.filtros,
                        search: this.search,
                        medico: this.medico ? this.medico.id_pessoa : null,
                        flat: true,
                    },
                });

            });
        },

        ver_criterio(id_rateio_medico) {
            this.$refs.cadrateio.editar(id_rateio_medico);
        },
    },

    mounted() {
        // this.load();

        this.$store.commit("setBreadcrumb", [
            { name: "Repasse", path: "" },
            { name: "Rateios", path: "/repasse/rateios" }
        ]);
    }
}
</script>

